import { localDateTimeFromString } from "@shared/utils/formatters/dates"
import makeUUID from "@shared/utils/helpers/makeUUID"
import { Trip } from "./types"
import { generateTripVehicle, MockTripVehicle } from "../vehicles"
import { generateAnalytics, MockAnalytics } from "../types.test.helper"

export type MockTrip = Omit<Partial<Trip>, "id" | "startedAt" | "finishedAt" | "analytics" | "vehicle"> & {
  id?: string
  vehicle?: MockTripVehicle
  startedAt?: string
  finishedAt?: string
  analytics?: MockAnalytics
}

export const generateTrip = (mockTrip?: MockTrip): Trip => ({
  vehicle: generateTripVehicle(mockTrip?.vehicle),
  id: makeUUID(mockTrip?.id),
  startedAt: mockTrip?.startedAt
    ? localDateTimeFromString(mockTrip.startedAt)
    : localDateTimeFromString(`2022-05-05T12:45:29Z`),
  finishedAt: mockTrip?.finishedAt
    ? localDateTimeFromString(mockTrip.finishedAt)
    : localDateTimeFromString(`2022-05-05T12:53:00Z`),
  analytics: generateAnalytics(mockTrip?.analytics),
})

export const generateTrips = (mockTrips: Array<MockTrip>): ReadonlyArray<Trip> =>
  mockTrips.map((it) => generateTrip(it))
